const styles = (theme) => ({
    dataGrid: {
      border: `1px solid ${theme.AppBGColor}`,
      '& .ag-theme-material .ag-body-horizontal-scroll': {
        borderWidth: '0px'
      },
      '& .statusBar': {
        display: 'none'
      },
      '& .driver-status-container': {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
      },
      '& .driver-status-icon-container': {
        width: '10%'
      },
      '& .driver-status-icon': {
        fill: `${theme.HeaderSelectedText}`
      },
      '& .driver-status-stopType': {
        border: `1px solid ${theme.HeaderSelectedText}`,
        width: 16,
        height: 16,
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 3
      },
      '& .driver-status-stopType-delivery': {
        borderRadius: '50%'
      },
      '& .driver-status-label': {
        width: '90%',
        paddingLeft: '5px'
      },
      '& .linkText': {
        cursor: 'pointer',
        textDecoration: 'underline',
        marginRight: 4
      },
      '& .stopNumber':{
        border: "1px solid",
        padding: "0px 5px",
        borderRadius: "11px",
        marginRight: "3px",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      '& .displayName':{
        alignItems: "center",
        display:"flex"
      }
    },
    container: {
      paddingTop: 4,
      padding:1,
      height: 'calc(100% - 86px)'
    }
  });
  
  export default styles;
  